import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmRoutingModule } from 'src/app/applications/cm/cm-routing.module';
import { SideNavService } from '../../shared/layouts/side-nav/services/side-nav.service';
import CompanySidenavConfig from '../../applications/cm/companySidenavConfig';
/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * NOTE THAT THIS MODULE WILL BE LOADED IN THE APP.
 * DO NOT IMPORT ANYTHING IN HERE.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

@NgModule({
  declarations: [],
  imports: [CommonModule, CmRoutingModule],
  exports: [],
  providers: [],
})
export class CmModule {
  constructor(private sideNavService: SideNavService) {
    /**
     * CODE IN HERE WILL BE EXECUTED ON APP LOAD.
     * USE IT TO INJECT YOUR SUB APP INTO THE MAIN APPLICATION
     */
    this.sideNavService.addSubMenuItems(
      'company_application',
      CompanySidenavConfig.companyManagementLinks
    );
    this.sideNavService.addSubMenuItems(
      'setting',
      CompanySidenavConfig.companyManagementSettingsLinks
    );
  }
}
